export default __webpack_public_path__ + "static/media/single-arrow-left.9bbe7570.svg";